export default __webpack_public_path__ + "static/media/Bindings of the Reanimator.28959eeb.jpg";